export const getTenant = () => {
  const parts = window.location.hostname.split(".");
  let last_index = -2;
  const last = parts[parts.length - 1];
  const is_localhost = last === "localhost";
  if (is_localhost) {
    last_index = -1;
  }

  const subdomain = parts.slice(0, last_index).join(".");

  if (!subdomain) {
    return "www";
  }
  return subdomain;
};

export const getRootDomain = (hostname = window.location.hostname) => {
  const parts = hostname.split(".");
  const last = parts[parts.length - 1];
  const last_index = last === "localhost" ? -1 : -2;
  return parts.slice(last_index).join(".");
};

// The slug identifying Virtual Officer's own tenant — the same literal already relied on
// by canSwitchTenant below and by CompanyService.getCompanyRolesBySlug (vo-api-company),
// and mirrored on the backend as `process.env.VO_GLOBAL_COMPANY_KEY ?? "vo"` (see
// company.controller.ts's ops-dashboard route). Not env-driven on the frontend — this file
// never was, and 'vo' is the established literal, not a new convention.
export const VO_TENANT_SLUG = 'vo';

export const isVoTenant = (slug) => slug === VO_TENANT_SLUG;

// SPEC-AUTH-003 FR-8: the tenant-switcher must never render for a user who could never
// legitimately use it. Both conditions are required (AND, not OR) — an otherwise-eligible
// role sitting in a plain customer tenant (not 'vo', not a partner) still can't switch.
export const SWITCH_ELIGIBLE_ROLES = ['consultant', 'admin_customer', 'admin_global', 'super_admin_global'];

export const canSwitchTenant = (roleActive, homeCompany, tenant = getTenant()) => {
  const isEligibleHome = isVoTenant(tenant) || homeCompany?.partner === true;
  return isEligibleHome && SWITCH_ELIGIBLE_ROLES.includes(roleActive);
};
